import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthorisationService } from '../../services/authorisation/authorisation.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(public auth: AuthorisationService, public router: Router) { }

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
    //to do change
    //  this.auth.logout();
    //  this.auth.logoutExpireToken();
     this.router.navigate(['/error',{id:413}]);
      return false;
    }
    return true;
  }
}